import React from 'react'
import PropTypes from 'prop-types'

const BrandLogo = ({
  brand, render, size, type,
}) => {
  if (!brand[type]) return null

  const logoUrl = brand[type][size]

  return render({
    url: logoUrl,
  })
}

BrandLogo.propTypes = {
  brand: PropTypes.object.isRequired,
  size: PropTypes.string,
  type: PropTypes.string,
}

BrandLogo.defaultProps = {
  size: 'small',
  type: 'logo',
}

export default BrandLogo
